import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import _ from "lodash";

const CustomHook = (props) => {
  const { gameReducer, paramsReducer } = props;
  const gameCode = _.get(gameReducer, "roomObj.game_code");
  return <>{gameCode === "VB" && <VBHook {...props} />}</>;
};

const VBHook = (props) => {
  const [prevRound, setPrevRound] = useState(0);
  const { gameReducer, paramsReducer } = props;
  const [prevStatus, setPrevStatus] = useState("");
  const defaultTrack = _.get(paramsReducer, "gameObj.tabletop_default_sound");
  const resultTrack = _.get(paramsReducer, "gameObj.tabletop_timer_end_sound");
  const scoreTrack = _.get(paramsReducer, "gameObj.tabletop_score_sound");
  const skipTrack = _.get(paramsReducer, "gameObj.tabletop_skip_sound");
  const buzzerTrack = _.get(paramsReducer, "gameObj.tabletop_buzzer_sound");

  const [audioTrack, setAudioTrack] = useState(defaultTrack);
  const status = _.get(gameReducer, "roomObj.game_state.status");
  const gameCode = _.get(gameReducer, "roomObj.game_code");
  const rightWordA =
    _.get(gameReducer, "roomObj.game_state.right_words_a") || [];
  const rightWordB =
    _.get(gameReducer, "roomObj.game_state.right_words_b") || [];
  const skipWordA =
    _.get(gameReducer, "roomObj.game_state.skipped_words_a") || [];
  const skipWordB =
    _.get(gameReducer, "roomObj.game_state.skipped_words_b") || [];
  const currentRound =
    _.get(gameReducer, "roomObj.game_state.current_round") || 1;
  const [prevRightWords, setPrevRightWords] = useState(0);
  const [prevSkipWords, setPrevSkipWords] = useState(0);

  useEffect(() => {
    setPrevRound(currentRound);
  }, []);

  useEffect(() => {
    if (status === "Joining") {
      setPrevStatus(status);
    } else if (prevStatus !== status && status === "ResultRound") {
      playAudio(resultTrack)
      setPrevStatus(status);
    }
    else if (prevStatus !== status && status === "ResultTurn") {
      playAudio(resultTrack)
      setPrevStatus(status);
    }
    else if (
      prevStatus &&
      status &&
      prevStatus !== status &&
      status !== "Joining" &&
      status !== "Over" && status !== "ResultTurn" && status !== "ResultRound"
    ) {
      setAudioTrack(defaultTrack);
      gameVBStatusTrack();
      setPrevStatus(status);
    }
  });

  useEffect(() => {
    const totalRightWords = rightWordA.length + rightWordB.length;
    if (
      totalRightWords > prevRightWords &&
      prevRound === currentRound &&
      status !== "ResultTurn"
    ) {
      playAudio(scoreTrack);
      setPrevRightWords(totalRightWords);
    } else if (prevRound !== currentRound || status === "ResultTurn") {
      setPrevRound(currentRound);
      setPrevRightWords(totalRightWords);
    }
  }, [rightWordA, rightWordB]);

  useEffect(() => {
    const totalSkipWords = skipWordA.length + skipWordB.length;
    if (
      totalSkipWords > prevSkipWords &&
      prevRound === currentRound &&
      status !== "ResultTurn"
    ) {
      playAudio(skipTrack);
      setPrevSkipWords(totalSkipWords);
    } else if (prevRound !== currentRound || status === "ResultTurn") {
      setPrevRound(currentRound);
      setPrevSkipWords(totalSkipWords);
    }
  }, [skipWordA, skipWordB]);

  useEffect(() => {
    const { buzzInfo } = props.game3Reducer;
    if (buzzInfo) {
      playATrack("playBuzzTrack");
    }
  });

  const gameVBStatusTrack = () => {
    if (gameCode === "VB") {
      playATrack("playAudioTrack");
    }
  };

  const playAudio = (url) => {
    var audio = document.createElement("audio");
    audio.src = url;
    audio.style.display = "none";
    audio.autoplay = true;
    audio.onended = function () {
      audio.remove();
    };
    document.body.appendChild(audio);
  };

  const playATrack = (attr) => {
    const callAudioEl = document.getElementById(attr);
    if (callAudioEl) {
      callAudioEl
        .play()
        .then(() => { })
        .catch(() => { });
    }
  };

  return (
    <>
      <audio id="playAudioTrack" src={audioTrack}></audio>
      <audio id="playScoreTrack" src={scoreTrack}></audio>
      <audio id="playSkipTrack" src={skipTrack}></audio>
      <audio id="playBuzzTrack" src={buzzerTrack}></audio>
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  loaderDetails: state.loaderDetails,
  paramsReducer: state.paramsReducer,
  game3Reducer: state.game3Reducer,
});

export default connect(mapStateToProps, null)(CustomHook);
